import definition from './health-checker.service';

export default {
    name: 'HealthCheckerService',
    definition
};



// WEBPACK FOOTER //
// ./app/services/health-checker/index.js